/**
 * @format
 * @Description: 登录日志状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Serv from './LogLoginServ';
import Utils from 'utils';
import Cookie from 'js-cookie';
import { message } from 'antd';
import { get, map } from 'lodash';

useStrict(true);
class LogLoginMod {
  @observable
  editing = true;

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }
  defaultDate() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    end.setTime(end.getTime() + 60 * 1000);
    let date = [start, end];
    date = map(date, item => {
      return Utils.timeFormat(item);
    });
    return date;
  }
  getSortNo(item) {
    let index = 0;
    if (item.children && item.children.length) {
      item.children.forEach(item1 => {
        item1.sortNO > index;
        index = item1.sortNO;
      });
    }
    return index + 1;
  }
  @action addOrganization = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.addOrganization(params);
  };
  getListBeforeRequest(data) {
    let beginTime = get(data, ['time', '0', '_d']) ? Utils.timeFormat(get(data, ['time', '0', '_d'])) : get(data, ['time', '0'], '');
    let endTime = get(data, ['time', '1', '_d']) ? Utils.timeFormat(get(data, ['time', '1', '_d'])) : get(data, ['time', '1'], '');

    let obj = {
      pageNum: data.pageNum,
      pageSize: data.pageSize,
      beginTime: beginTime,
      endTime: endTime,
      tenantId: Cookie.get('tenant_id'),
      userName: data.userName || undefined
    };
    //console.log(55,obj)
    return obj;
  }
  getListAfterRequest(data) {
    map(data.list, (item, index) => {
      item.key = index;
    });
    return data;
  }
  changeDate(data) {
    let beginTime = get(data, ['0', '_d']) ? Utils.timeFormat(get(data, ['0', '_d'])) : '';
    if (Date.parse(beginTime) < new Date().getTime() - 3600 * 1000 * 24 * 180) {
      message.warn('开始时间最早为180天之前');
    }
  }
}

// ES6单例写法
export default new LogLoginMod();



// WEBPACK FOOTER //
// ./src/pages/LogManage/LogLogin/LogLoginMod.js